export default {
  companyLinks: [
    {
      key: 'envato',
      label: 'Envato.com',
      url: 'https://envato.com'
    },
    {
      key: 'envatoElements',
      label: 'Envato Elements',
      url: 'https://elements.envato.com'
    },
    {
      key: 'placeit',
      label: 'Placeit by Envato',
      url: 'https://placeit.net'
    },
    {
      key: 'envatoTuts',
      label: 'Envato Tuts+',
      url: 'https://tutsplus.com'
    },
    {
      key: 'allProducts',
      label: 'All Products',
      url: 'https://envato.com/products'
    },
    {
      key: 'sitemap',
      label: 'Sitemap',
      url: 'https://envato.com/sitemap'
    },
    {
      key: 'milkshake',
      label: 'Milkshake',
      url: 'https://milkshake.app'
    }
  ],
  infoLinks: [
    {
      key: 'envato',
      titleHtml: 'Envato Market',
      entries: [
        {
          key: 'terms',
          label: 'Terms',
          url: 'https://themeforest.net/legal/market'
        },
        {
          key: 'licenses',
          label: 'Licenses',
          url: 'https://themeforest.net/licenses'
        },
        { key: 'api', label: 'Market API', url: 'https://build.envato.com' },
        {
          key: 'affiliate',
          label: 'Become an affiliate',
          url: 'https://envato.com/market/affiliate-program'
        }
      ]
    },
    {
      key: 'help',
      titleHtml: 'Help',
      entries: [
        {
          key: 'helpCenter',
          label: 'Help Center',
          url: 'https://help.market.envato.com'
        },
        {
          key: 'authors',
          label: 'Authors',
          url: 'https://help.author.envato.com/hc/en-us'
        }
      ]
    },
    {
      key: 'community',
      titleHtml: 'Our Community',
      entries: [
        {
          key: 'community',
          label: 'Community',
          url: 'http://community.envato.com'
        },
        {
          key: 'blog',
          label: 'Blog',
          url: 'https://envato.com/blog'
        },
        {
          key: 'forums',
          label: 'Forums',
          url: 'https://forums.envato.com'
        },
        {
          key: 'meetups',
          label: 'Meetups',
          url: 'http://community.envato.com/#/events'
        }
      ]
    },
    {
      key: 'meetEnvato',
      titleHtml: 'Meet Envato',
      entries: [
        {
          key: 'about',
          label: 'About Envato',
          url: 'https://envato.com'
        },
        {
          key: 'careers',
          label: 'Careers',
          url: 'http://careers.envato.com'
        },
        {
          key: 'privacy',
          label: 'Privacy Policy',
          url: 'https://envato.com/privacy/'
        },
        {
          key: 'sitemap',
          label: 'Sitemap',
          url: 'https://envato.com/sitemap/'
        }
      ]
    }
  ],
  socialMediaLinks: [
    {
      key: 'twitter',
      label: 'Twitter',
      url: 'https://twitter.com/envato',
      icon: '/images/icon-twitter.svg'
    },
    {
      key: 'facebook',
      label: 'Facebook',
      url: 'https://www.facebook.com/envato',
      icon: '/images/icon-facebook.svg'
    },
    {
      key: 'youtube',
      label: 'YouTube',
      url: 'https://www.youtube.com/user/Envato',
      icon: '/images/icon-youtube.svg'
    },
    {
      key: 'instagram',
      label: 'Instagram',
      url: 'https://www.instagram.com/envato/',
      icon: '/images/icon-instagram.svg'
    },
    {
      key: 'pinterest',
      label: 'Pinterest',
      url: 'https://www.pinterest.com/envato/',
      icon: '/images/icon-pinterest.svg'
    }
  ]
}
